import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { GameData } from "../Channels/Common/Datas/GameData";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator, WinAnimatorAttributes } from "../GameComponents/WinAnimator";
import { Tweens } from "../Components/Effects/Tweens";
import { PlayList } from "../Components/Sounds/PlayList";
import { SoundManager } from "../Components/Managers/SoundManager";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        this.impactSpecialSymbols(reelsData, reelIndex);
    }

    private impactSpecialSymbols(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.impactStars(reelsData, reelIndex);
        this.impactWilds(reelsData, reelIndex);
    }

    private impactStars(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        let canImpact: boolean = true;
        let count: number = this.calculatePreviousStars(reelsData, reelIndex, 8);

        if (reelIndex === 3) {
            if (count < 1) {
                canImpact = false;
            }
        } else if (reelIndex === 4) {
            if (count < 2) {
                canImpact = false;
            }
        }

        if (canImpact) {
            if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
                for (let i: number = 0; i < reelsData[reelIndex].symbols.length; i++) {
                    if (reelsData[reelIndex].symbols[i] === 8 && this.currentSymbols[reelIndex][i] != null) {
                        this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
                        PlayList.play("SND_BaseScatter0" + (count + 1));
                    }
                }
            }
        }
    }

    private impactWilds(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
            for (let i: number = 0; i < reelsData[reelIndex].symbols.length; i++) {
                if (reelsData[reelIndex].symbols[i] === 7 && this.currentSymbols[reelIndex][i] != null) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
                    PlayList.play("SND_BaseWildStop");
                }
            }
        }
    }

    private calculatePreviousStars(
        reelsData: Array<Communication.Game.IReel>,
        reelIndex: number,
        symbolId: number,
    ): number {
        let count: number = 0;
        for (let j: number = 0; j < reelIndex; j++) {
            if (reelsData[j] != null && reelsData[j].symbols != null) {
                for (let i: number = 0; i < reelsData[j].symbols.length; i++) {
                    if (reelsData[j].symbols[i] === symbolId) {
                        count++;
                    }
                }
            }
        }

        return count;
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        if (
            (this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_2" ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_3") &&
            caseType === Symbol.CaseNormal
        ) {
            return false;
        }

        return true;
    }

    protected getIdleDelay(): number {
        return 30;
    }

    protected getInitialIdleDelay(): number {
        return 30;
    }

    protected getIdleActiveElementsCount(): number {
        return 2;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/